
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.235 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.929 1.862a7.617 7.616 0 01-1.327.447A4.135 4.135 0 0018.695.57a.217.217 0 00-.317-.253 7.653 7.652 0 01-2.029.838.517.517 0 01-.127.016.537.537 0 01-.355-.136A4.147 4.147 0 0013.123 0a4.434 4.434 0 00-1.314.2A4.018 4.018 0 009.1 3.098 4.424 4.424 0 009 4.625a.148.148 0 01-.037.116.154.154 0 01-.114.052h-.01A10.874 10.873 0 011.362.8a.217.217 0 00-.355.028 4.143 4.143 0 00-.562 2.085 4.142 4.142 0 001.236 2.955 3.717 3.717 0 01-.946-.366.217.217 0 00-.322.187 4.152 4.152 0 002.423 3.825h-.089a3.731 3.73 0 01-.7-.067.217.217 0 00-.247.28 4.156 4.156 0 003.284 2.827A7.652 7.651 0 01.8 13.856H.32a.318.318 0 00-.31.239.329.329 0 00.157.363A11.382 11.38 0 005.886 16a11.538 11.537 0 004.888-1.037 10.793 10.792 0 003.576-2.68 11.748 11.747 0 002.19-3.667 11.585 11.584 0 00.743-4.013V4.54a.706.706 0 01.264-.55A8.2 8.2 0 0019.2 2.178a.217.217 0 00-.268-.32z"}})])
          )
        }
      }
    